var map = {
	"./10_nuts.png": 7037,
	"./1drink_12beer.png": 515,
	"./1serving_8ounces.png": 7320,
	"./1serving_8ounces2.png": 8241,
	"./1serving_8ounces3.png": 2246,
	"./1serving_8ounces4.png": 792,
	"./1serving_8ounces5.png": 9147,
	"./8ounces_1glass.png": 7053,
	"./can_1.png": 368,
	"./can_2.png": 9606,
	"./can_3.png": 4283,
	"./cup.png": 2301,
	"./dried_serving_1/4cup.png": 5273,
	"./dried_serving_1:4cup.png": 9514,
	"./fresh_serving_1cup.png": 4054,
	"./glass_1.png": 1626,
	"./glass_2.png": 448,
	"./golfball.png": 271,
	"./halfthumb.png": 2846,
	"./hand_1.png": 1697,
	"./hand_2.png": 2251,
	"./hand_3.png": 2080,
	"./hand_4.png": 1309,
	"./hand_5.png": 2900,
	"./how.png": 5326,
	"./serving_1/2cup.png": 9469,
	"./serving_1:2cup.png": 2776,
	"./serving_1tbsp.png": 983,
	"./serving_3/4ounces.png": 4570,
	"./serving_3:4ounces.png": 7719,
	"./thumbx2.png": 567,
	"./usda.png": 5933,
	"./vegetables_1cup.png": 3697,
	"./what.png": 3260,
	"./wholethumb.png": 3298,
	"./why.png": 6796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8588;